module.exports = __webpack_public_path__ + "static/img/v2.a5e8cec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/v2.jpg
// module id = c+qN
// module chunks = 1